import * as VisuallyHiddenPrimitive from '@radix-ui/react-visually-hidden'
import type { ReactNode } from 'react'

export interface VisuallyHiddenProps {
  children: ReactNode
  asChild?: boolean
}

/**
 * Visually hides content while keeping it accessible to screen readers.
 * Use for screen-reader-only labels and announcements.
 */
export function VisuallyHidden({ children, asChild }: VisuallyHiddenProps) {
  return (
    <VisuallyHiddenPrimitive.Root asChild={asChild}>
      {children}
    </VisuallyHiddenPrimitive.Root>
  )
}
